/**
 * Created by slava on 01.08.17.
 */

const ExplosionView = cc.Node.extend({
    ctor: function () {
        this._super();

        const sprite = new cc.Sprite(bundles.explosion.frames.boom_frames_1);
        this.addChild(sprite);
        sprite.setScale(1.2);
        this.sprite = sprite;

        this.frames = [];
        for (let i = 1; bundles.explosion.frames[`boom_frames_${i}`]; i++) {
            this.frames.push(bundles.explosion.frames[`boom_frames_${i}`]);
        }
    },

    animate: function (color) {
        if (this.spine) {
            this.spine.setColor(color);
            this.spine.setAnimation(0, "animation", false);
            this.spine.setCompleteListener(() => {
                cleverapps.pool.putInPool(this);
            });
        } else {
            this.sprite.setColor(color);
            this.sprite.runAction(new cc.Sequence(
                new cc.Animate(this.frames, cleverapps.styles.ExplosionView.frame.duration / this.frames.length),
                new cc.CallFunc(() => { 
                    cleverapps.pool.putInPool(this);
                })
            ));
        }
    },

    reuse: function () {
        this.visible = true;
        this.setScale(1);
    },

    unuse: function () {
        this.visible = false;
        this.removeFromParent(false);
    }
});

ExplosionView.fillPool = function () {
    for (let i = 0; i < 6; i++) {
        cleverapps.pool.putInPool(new ExplosionView());
    }
};

ExplosionView.factory = function () {
    return cleverapps.pool.hasObject(ExplosionView) ? cleverapps.pool.getFromPool(ExplosionView) : undefined;
};

cleverapps.styles.ExplosionView = {
    frame: {
        duration: 0.15
    }
};